module.exports = __webpack_public_path__ + "assets/images/01-active_1068e19a2cf0525546ceb0a636f05d91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-two/exercise-1/01-active.png
// module id = 224
// module chunks = 0